export default ({ store, redirect }) => {
  // if (!store.state.intro.intro) {
  //   return redirect('/')
  // } 

  if (store.state.member.auth.token) {
    return redirect('/home')
  }
}
